/*
 * A React mixin to reduce boilerplate code
 * when dealing with requiring and binding to models.
 */

import _ from 'underscore';
import MS from './store';

export default {
  _models() {
    if (this.model) {
      return [this.model];
    }
    if (this.models) {
      return this.models;
    }
    return undefined;
  },

  _resolveId(model, props) {
    props = props === undefined ? this.props : props;

    switch (typeof model.id) {
      case 'string':
        /* A simple prop */
        if (props[model.id] === undefined) {
          throw `Can't resolve if of model: ${JSON.stringify(
            model
          )} for props: ${JSON.stringify(props)}`;
        }
        return props[model.id];
      case 'function':
        /* A function that returns the id */
        return model.id.call(this, props);
      default:
        return undefined;
    }
  },

  _bindModel(model, idx, props) {
    this._modelInstances[idx] = MS.require(
      model.type,
      this._resolveId(model, props)
    );
    this._modelCallbacks[idx] = _.bind(model.onState, this);
    MS.bind(this._modelInstances[idx], this._modelCallbacks[idx]);
  },

  _releaseModel(model, idx) {
    MS.unbind(this._modelInstances[idx], this._modelCallbacks[idx]);
  },

  componentDidMount() {
    const _this = this;

    this._modelInstances = [];
    this._modelCallbacks = [];

    _.each(this._models(), (model, idx) => {
      _this._bindModel(model, idx);
    });
  },

  componentWillUnmount() {
    const _this = this;

    _.each(this._models(), (model, idx) => {
      _this._releaseModel(model, idx);
    });

    delete this._modelInstances;
    delete this._modelCallbacks;
  },

  UNSAFE_componentWillReceiveProps(nextProps) {
    _.each(
      this._models(),
      _.bind(function (model, idx) {
        if (
          this._modelInstances[idx].id !== this._resolveId(model, nextProps)
        ) {
          this._releaseModel(model, idx);
          this._bindModel(model, idx, nextProps);
        }
      }, this)
    );
  },
};
